import { CSSProperties } from 'react';

// Utils
import { combineClasses } from '@/utils/className';

interface DotGridProps {
  className?: string;
  style?: CSSProperties;
  name?: string;
}

export const DotGrid = ({ className, style, name }: DotGridProps) => (
  <div
    data-name={name}
    className={combineClasses(
      'absolute bg-[radial-gradient(circle,#ffffff_2px,transparent_2px)] bg-[length:30px_30px] bg-[position:15px_15px] [background-blend-mode:overlay]',
      className,
    )}
    style={style}
  />
);
